module.exports = __webpack_public_path__ + "img/f6-03.4ce8d505.png";